module.exports = __webpack_public_path__ + "img/6.ce0a8e9f.jpg";